import React, { useContext } from "react";
import { css } from "emotion";
import SettingsLink from "./SettingsLink";
import GenericCard from "../GenericCard";
import InfoTitle from "../InfoTitle";
import LogoutButton from "../sidebar/LogoutButton";
import { GlobalContext } from "../../context/GlobalState";

const SettingsDesktop = () => {
  const { userData, currentWorkspace } = useContext(GlobalContext);

  const isAdmin = userData.isAdmin || (userData.hasOwnProperty('roles') && userData.roles.hasOwnProperty(currentWorkspace.id) && userData.roles[currentWorkspace.id].role === 'admin');

  return (
    <div className={container}>
      <InfoTitle title="Settings" />
      <GenericCard style="main-card">
        <SettingsLink route="account" />
        {isAdmin && <SettingsLink route="billing" />}
        {isAdmin && <SettingsLink route="users" />}
        <SettingsLink route="switch" />
      </GenericCard>
      <LogoutButton/>
    </div>
  );
};

export default SettingsDesktop;

const container = css`
  width: 80%;
  padding-top: 30px;
  margin: auto;
  .main-card {
    flex-direction: column;
    width: 100%;
  }
`;
